import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {SoundFilter, SoundItem, CallSoundsState, uploadSound} from "./types";

export const actions: ActionTree<CallSoundsState, RootState> = {
  getSounds: ({commit, dispatch}, data: SoundFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/call/sounds', params: data})
        .then((resp: any) => {
          if (data.page_number && data.page_number > 1) {
            commit('pushSounds', resp.data.sounds);
          } else {
            commit('setSounds', resp.data.sounds);
          }
          resolve(resp);
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getSoundItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/call/sounds/${id}`})
        .then((resp:any) => {
          let soundsItem = <SoundItem>resp.data;
          soundsItem.id = id;
          commit('setSoundItem', soundsItem);
          resolve(soundsItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  uploadSound: ({commit}, payload: uploadSound) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ method: 'post', url: '/acapi/call/sounds', data: payload })
        .then((resp: any) => resolve(resp.data))
        .catch(reject)
        .finally(() => commit('setLoading', false));
    })
  },
  deleteSound: ({commit, dispatch}, data: SoundItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/call/sounds/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getSounds');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
};
